import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { Building2, CheckCircle2, Clock, XCircle, CalendarCheck, CreditCard, Loader2, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

const Stat = ({ icon: Icon, label, value, accent, to }) => (
  <Link to={to} className="rounded-xl border border-border bg-card p-5 block transition-all duration-200 hover:shadow-md hover:-translate-y-1" data-testid={`admin-stat-${label}`}>
    <div className={cn("w-10 h-10 rounded-lg flex items-center justify-center mb-3", accent)}>
      <Icon className="w-5 h-5" />
    </div>
    <p className="text-3xl font-bold font-display">{value}</p>
    <p className="text-sm text-muted-foreground mt-0.5">{label}</p>
  </Link>
);

export default function AdminDashboard() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-stats"], queryFn: () => api.get("/admin/stats").then((r) => r.data), staleTime: 0, refetchOnMount: "always" });
  if (isLoading || !data)
    return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <h1 className="text-3xl font-bold">Genel Bakış</h1>
        <p className="text-muted-foreground mt-1">Platform geneli istatistikler</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        <Stat icon={Building2} label="Toplam İşletme" value={data.total_businesses} accent="bg-indigo-100 text-indigo-600" to="/admin/isletmeler" />
        <Stat icon={CheckCircle2} label="Aktif Abonelik" value={data.active} accent="bg-emerald-100 text-emerald-600" to="/admin/isletmeler" />
        <Stat icon={Clock} label="Deneme Süreci" value={data.trial} accent="bg-blue-100 text-blue-600" to="/admin/isletmeler" />
        <Stat icon={XCircle} label="Süresi Dolan" value={data.expired + data.suspended} accent="bg-red-100 text-red-600" to="/admin/isletmeler" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
        <Stat icon={CalendarCheck} label="Toplam Rezervasyon" value={data.total_reservations} accent="bg-amber-100 text-amber-600" to="/admin/rezervasyonlar" />
        <Stat icon={CreditCard} label="Aktif Plan" value={data.active_plans} accent="bg-violet-100 text-violet-600" to="/admin/planlar" />
        <Stat icon={TrendingUp} label="Toplam Gelir" value={money(data.total_revenue)} accent="bg-teal-100 text-teal-600" to="/admin/rapor" />
      </div>
    </div>
  );
}
